import { render, staticRenderFns } from "./MainIE.vue?vue&type=template&id=608bcd55&scoped=true&"
import script from "./MainIE.vue?vue&type=script&lang=js&"
export * from "./MainIE.vue?vue&type=script&lang=js&"
import style0 from "./MainIE.vue?vue&type=style&index=0&id=608bcd55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608bcd55",
  null
  
)

export default component.exports